export const ANONYMOUS_CUSTOMER_ID = "00000000-0000-0000-0000-000000000000";
